import {Box} from 'platform/foundation';
import {css} from 'styled-components';

import {CardOo} from '../../components/CardOo/CardOo';
import {useGetOnlineOfferData} from '../../hooks/useGetOnlineOfferData';
import {ReservationPrices} from './ReservationPrices';
import {hasReservationPrices} from './utils/hasReservationPrices';

export function ReservationCardPrint() {
  const offer = useGetOnlineOfferData();

  if (!hasReservationPrices(offer)) {
    return null;
  }

  return (
    <div
      css={css`
        page-break-inside: avoid;
      `}
    >
      <Box width="100%" overflow="hidden" paddingHorizontal={10} paddingVertical={5}>
        <CardOo backgroundColor="semantic.bg.subtle">
          <ReservationPrices />
        </CardOo>
      </Box>
    </div>
  );
}
